import { snakeStore, DATA } from '@app/plugins/vuex-async-pagginate';
import { RecipientService } from '@db/services/RecipientService';

export const recipients = snakeStore(
  {
    state: {
      fields: null,
      total: 0
    },
    actions: {
      getData: (_, params) => RecipientService.getImportData(params),
      updateItemById: ({ getters, commit }, value) => {
        commit(
          DATA,
          [...getters[DATA]].map(i => {
            return i.id === value.id ? { ...i, ...value } : i;
          })
        );
      },
      importRecipients: ({ commit }, items) => commit('importFields', items),
      importRecipientsTotal: ({ commit }, items) => commit('importFieldsTotal', items)
    },
    mutations: {
      importFields: (state, value) => state.fields = value,
      importFieldsTotal: (state, value) => state.total = value
    },
    getters: {
      getImportFields: state => state.fields,
      getImportFieldsTotal: state => state.total
    }
  },
  true
);
